























import Vue from 'vue'
import PhotoGrid from "@/components/PhotoGrid.vue";
import {Media} from "@/ts/Media";
import {months, scrollBarWidth} from "@/ts/constants";

export default Vue.extend({
    name: 'DateSearch',
    components: {PhotoGrid},
    data: () => ({
        loading: false,
        endIndex: 100,
        prevScroll: -10000,
        searchElement: {} as HTMLDivElement,
        photoGrid: null as any,
    }),
    async mounted() {
        this.photoGrid = this.$refs.photoGrid;
        this.searchElement = this.$refs.search as HTMLDivElement;
        await this.updateSearch();
    },
    methods: {
        async updateSearch() {
            this.loading = true;
            await this.$store.dispatch('dateSearch', {day: this.day, month: this.month});
            this.loading = false;
        },
        async homeScroll() {
            let scrollTop = this.searchElement.scrollTop;
            // If we haven't scrolled more than 180px since last scroll fire just return
            if (Math.abs(this.prevScroll - scrollTop) < 180)
                return;
            this.prevScroll = scrollTop;

            let scrollBottom = this.searchElement.scrollHeight - scrollTop - this.searchElement.clientHeight;
            if (scrollBottom < 3000 && this.endIndex < this.results.length) {
                this.endIndex += 100;
            }
        },
    },
    computed: {
        pagePadding(): number {
            return this.$vuetify.breakpoint.mobile ? 0 : 10;
        },
        usableWidth(): number {
            return this.$vuetify.breakpoint.width -
                this.$vuetify.application.left - this.$vuetify.application.right -
                this.pagePadding * 2 - scrollBarWidth;
        },
        day(): number | null {
            let day = +this.$route.params.day;
            return isNaN(day) ? null : day;
        },
        month(): number | null {
            let monthString = this.$route.params.month;
            if (monthString === undefined || monthString === null)
                return null;
            return months.indexOf(monthString as string) + 1;
        },
        slicedPhotos(): Media[] {
            return this.results.slice(0, this.endIndex);
        },
        results(): Media[] {
            return this.$store.state.dateResults;
        },
    },
    watch: {
        day() {
            this.updateSearch();
        },
        month() {
            this.updateSearch();
        },
        results() {
            this.$store.commit('viewerQueue', this.results);
        },
        '$store.state.keepInView'() {
            if (this.$store.state.keepInView !== null) {
                let photoGrid: any = this.$refs.photoGrid;
                photoGrid.scrollMediaIntoView(this.$store.state.keepInView);
            }
        },
    }
})
